module.exports = __webpack_public_path__ + "static/Certificate_PCI_DSS_LLC_2026-41e4a5c6de8caa96eb6fa36209f089d9.pdf";